// Setup Vue
import { createApp } from 'vue'
window.Vue = createApp;
window.$ = window.jQuery = jQuery;

// Our extensions and components
import Axios from './classes/Axios.js';
import modalDynamic from './components/modal-dynamic.vue';
import Paystubs from './components/Paystubs.vue';
import OneRevDialog from './components/OneRevDialog.vue';
import UtilitiesMixin from './mixins/UtilitiesMixin';
require ('./classes/PrototypeExt.js');

var app = createApp({

    components: {
        'modal-dynamic': modalDynamic,
        Paystubs,
        OneRevDialog,
    },

    mixins: [UtilitiesMixin],

    data() {
        return {
            locale: ( window.navigator.languages && window.navigator.languages.length ? window.navigator.languages[0] : window.navigator.language) || 'en-US',
            true: true,  // necessary to pass a boolean true and not a string
            false: false,  // necessary to pass a boolean true and not a string
            modals: [],  // Dynamic modals
            openModals: 0,  // Dynamic modals counting
            buttonYesAction: [],
            buttonNoAction: [],
            button3Action: [],
            oasisApi: new Axios('/restv2'),

            // employees/locations retrieved from database
            timecards: [],
            unapprovedTimecards: [],
            departments: [],
            entityId: entityId,
            weekEnding: '',
            weekFilter: '',
            weekFilterNew: '',
            weekEndings: [],
            weekEndingsNew: [],
            showFilter: '',
            showFilterNew: '',
            shows: [],
            showsNew: [],
            incomplete: undefined,

            // Checkbox details
            selectedTimecards: [],
            disableTimecards: disableTimecards,

            enablePaystubs: false,
            showPaystubList: false,
            showPaycheckBanner: paycheckBannerFlag === 'true' ? (localStorage.getItem("showPaycheckBanner") === 'false' ? false : true) : false,
            showPaperlessBanner: paperlessBannerFlag === 'true' ? (localStorage.getItem("showPaperlessBanner") === 'false' ? false : true) : false,
            showOneRevDialog: false,
            employee: undefined,
            assignment: undefined,
        }
    },

    computed: {
        allTimecards() {
            if (this.timecards.length === 0) return '';

            let show = '';
            let weekEnding = '';
            if (this.showFilter) {
                show = new RegExp(this.showFilter, 'i');
            }
            if (this.weekFilter) {
                weekEnding = new RegExp(this.weekFilter.long, 'i');
            }
            return this.timecards.filter(function ({ entity, status, week_ending }) {
                return (entity.match(show) && week_ending.match(weekEnding) && parseInt(status) >= 0 && parseInt(status) < 5);
            });
        },

        papercheckOptin: {
            // get: (() => {
            get: function() {
                if (!this.employee) return null;
                return this.employee.papercheck_optin && this.employee.papercheck_optin > 0 ? true : false;
            },
            // set: ((value) => {
            set: function(value) {
                this.employee.papercheck_optin = value ? 1 : 0;
            }
        }
    },

    methods: {
        addShow(data, array) {
            array.pushUnique(data);
            return data;
        },

        addDate(date, array) {
            let newDate = this.convertDate(date);
            array.pushUniqueDate({ "short": newDate, "long": date });
            return newDate;
        },

        convertDate(date) {
            if (! date) return false;

            let newDate = new Date(date);
            if (this.locale === 'en-CA') { 
                newDate = newDate.toLocaleDateString('en-GB', {
                    year: 'numeric',
                    day: '2-digit',
                    month: '2-digit',
                });
            } else {
            newDate = newDate.toLocaleDateString(this.locale, {
                year: 'numeric',
                day: '2-digit',
                month: '2-digit',
                });
            }
            return newDate;
        },

        getDaysWorked (timecard) {
            let days = 0
            if (!timecard) return days;
            days += (timecard.broken_object && (timecard.broken_object.week || {}).daysWorked) || 0;
            days += (timecard.broken_object2 && (timecard.broken_object2.week || {}).daysWorked) || 0;
            return days;
        },

        getOT (timecard) {
            let expectedHours = (timecard.assignment_object.guaranteed_hours) ? parseFloat(timecard.assignment_object.guaranteed_hours) * 5 : 40;
            let expectedOT = (expectedHours > 40) ? (expectedHours - 40) : 0
            let actualOT = ((timecard.broken_object.week.pay_ot_15) ? timecard.broken_object.week.pay_ot_15.hours*1 : 0) + ((timecard.broken_object.week.pay_ot_2) ? timecard.broken_object.week.pay_ot_2.hours*1 : 0.00)
            let warning = false;

            // console.log (timecard.assignment_object.employee + ': ' + expectedHours + '/' + expectedOT + '/' + actualOT);
            if (actualOT > expectedOT) warning = true;
            return { value: actualOT.formatNumber(), warning: warning };
        },

        getComments(day) {
            let ee = '',
                er = '';

            for (let i in day) {
                if (!day[i] || typeof day[i] !== 'object') continue;
                if (day[i].hasOwnProperty('employee_comments')) {
                    ee += day[i].date.short + ": " + day[i].employee_comments + "<br /><br />";
                }
                if (day[i].hasOwnProperty('employer_comments')) {
                    er += day[i].date.short +  ": " + day[i].employer_comments + "<br /><br />";
                }
            }

            if (ee || er) {
                ee = ee.replace(/\"/g, "");  
                er = er.replace(/\"/g, "");  
                return '<a href="#" data-toggle="tooltip" data-html="true" title="<strong>EMPLOYEE COMMENTS</strong>:<br />' + ee + '<hr /><strong>EMPLOYER COMMENTS</strong>:<br />' + er +'">View</a>';
            } else {
                return '';
            }
        },

        approve(options) {
            if (this.selectedTimecards.length === 0) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to approve', "buttonNo": false, "buttonYesLabel": "OK"  });
                return false;
            }
            // Quick check 
            $("body").addClass('waiting');

            data = {
                timecards: this.selectedTimecards,
            };

            this.oasisApi.patch('/approve/timecard', data)
                .then(response => {
                    // console.log (typeof response.data);
                    if (response.status == 200){
                        this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                        if (response.data.ids && Array.isArray(response.data.ids)) {
                            for (let i=0; i <= response.data.ids.length; i++) {
                                let hash = response.data.ids[i];
                                if (hash) {
                                    let index = this.timecards.findIndex((el) => { return el.hash == hash });
                                    console.log (index, hash);
                                    this.timecards.splice(index,1);
                                }
                            }
                        }

                    } else if (response.status == 400) {
                        if (Array.isArray(response.data)) {
                            let message = '';
                            for (let i = 0; i < response.data.length; i++) {
                                let error = JSON.parse(response.data[i]);
                                $("input[name='" + error.field + "']").addClass('form-error2');
                                message += error.message + "\n";
                            }
                            this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                })
                .catch(error => { console.log('error: '); console.log(error); alert (error); });

            $("body").removeClass('waiting');
        },

        // Probably good forMixins!

        // Generic test function
        log(value) {
            console.log('Logging:');
            console.log(value);
        },

        createLink(value) {
            return value;
        },

        openTimecard(hash) {
            if( this.isMobile() ) {
                // redirects if mobile
                if (hash) window.location.href = `/mobiletimecard/index.html#/${hash}`;
                else window.location.href = `/mobiletimecard/index.html#/newTimecard`;
            } else {
                // redirects if whatever else
                if (hash) window.location.href = `/oasis/employee/createTimecard/${hash}`;
                else window.location.href = `/oasis/employee/createTimecard`;
            }
        },

        // Create a dynamic modal dialog box with buttons and labels
        createDialog(options) {
            let index = this.openModals;
            options.id = index;

            if (options.buttonYesAction) { this.buttonYesAction[index] = options.buttonYesAction;
            } else { this.buttonYesAction[index] = function () {}; }

            if (options.buttonYesLabel) { this.buttonYesLabel = options.buttonYesLabel;
            } else { options.buttonYesLabel = 'Yes'; }

            if (options.buttonNoAction) { this.buttonNoAction[index] = options.buttonNoAction;
            } else { this.buttonNoAction[index] = function () {}; }

            if (options.buttonNoLabel) { this.buttonNoLabel = options.buttonNoLabel;
            } else { options.buttonNoLabel = 'No'; }

            if (options.button3Action) { this.button3Action[index] = options.button3Action;
            } else { this.button3Action[index] = function () {}; }

            if (options.button3Label) { this.button3Label = options.button3Label;
            } else { options.button3Label = 'Maybe'; }

            this.modals.push(options);
            this.openModals++;
        },

        // Retrieve link to start PDFs
        printStart() {
            $("body").addClass('waiting');
            const endpoint = '/printStart/' + this.hash;

            this.oasisApi.get(endpoint)
                .then(response => {
                    // console.log (response);
                    if (response.status == 200 ) {
                        this.createDialog({ "title": "Start Paperwork", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    } else if (response.status == 400) {
                        this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                    $("body").removeClass('waiting');
                })
                .catch(error => {
                    $("body").removeClass('waiting');
                    console.log('error: '); console.log(error); 
                });
        },

        // Close the dynamic modal
        closeModal(index) {
            this.modals.splice(index, 1);
            this.buttonYesAction.splice(index, 1);
            this.buttonNoAction.splice(index, 1);
            this.button3Action.splice(index, 1);
            this.openModals--;
        },

        modalConfirm(index) {
            this.buttonYesAction[index]();
        },

        modalCancel(index) {
            this.buttonNoAction[index]();
        },

        modalButton3(index) {
            this.button3Action[index]();
        },

        hidePaycheckBanner() {
            this.showPaycheckBanner = false;
            localStorage.setItem("showPaycheckBanner", 'false');
            this.hidePaperlessBanner();
        },

        hidePaperlessBanner() {
            this.showPaperlessBanner = false;
            localStorage.setItem("showPaperlessBanner", 'false');
        },

        async updatePaperlessSetting() {
            const data = {
                employeeId: this.employee.id,
                assignmentId: this.assignment.id,
                employee: {
                    papercheck_optin: this.employee.papercheck_optin,
                }
            }

            try {
                const response = await this.oasisApi.patch('/employee/start/' + this.employee.hash, data)
                if (response.status == 200) {
                    this.createDialog({ "title": "Success", "body": 'Your paperless choice has been saved.', "buttonYesLabel": "OK", "buttonNo": false });
                } else if (response.status == 400) {
                    if (Array.isArray(response.data)) {
                        let message = '';
                        for (let i = 0; i < response.data.length; i++) {
                            let error = JSON.parse(response.data[i]);
                            $("#job1Form input[name='" + error.field + "']").addClass('form-error2');
                            message += error.message + "\n";
                        }
                        this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    } else {
                        this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                } else {
                    this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                }
                this.waiting = false;
            } catch (error) {
                console.log('error: '); console.log(error); alert (error);
                this.waiting = false;
            };
        },
    },

    watch: {
    },

    created() {
        this.hash = hash || '';

        if (timecards) {
            this.timecards = timecards;
        }

        if (unapprovedTimecards) {
            this.unapprovedTimecards = unapprovedTimecards;
        }

        if (typeof incomplete !== 'undefined' && incomplete.length) {
            this.incomplete = incomplete;
        }

        this.oasisApi.get('/employee/lookup/' + employeeHash)
            .then(response => {
                this.employee = response.data;
            }
        );
        this.oasisApi.get('/employee/start/' + hash)
            .then(response => {
                this.assignment = response.data;
            }
        );
        this.oasisApi.get('/entities')
            .then(response => {
                this.entity = response.data;
                if (response.data.hasOwnProperty('other_properties') && response.data.other_properties) {
                    const data = this.isJson(response.data.other_properties) ? JSON.parse(response.data.other_properties) : response.data.other_properties;
                    this.enablePaystubs = data.enablePaystubs || false;
                }
            })
    },

    beforeCreate() {
        $("body").addClass('waiting');
        this.oasisApi = new Axios('/restv2');
    },

    mounted() {
        $("body").removeClass('waiting');
        setTimeout(function() {$(function () { $('[data-toggle="tooltip"]').tooltip() })}, 500);

        if (typeof prompt !== 'undefined' && prompt) {
            let dialogOptions = {};
            if (this.disableTimecards) {
                dialogOptions = {
                    "title": "Thanks for using ProHire",
                    "body": "Timecard entry will be available upon employer approval.",
                    "buttonNoAction": function () { window.location.href = '/oasis/employee/logout' },
                    "buttonNoLabel": "Log Out",
                    "buttonYesLabel": "Ok"
                };
            }
            else {
                dialogOptions = {
                    "title": "Welcome to the ProHire Dashboard",
                    "body": "To continue, please select to see the dashboard or logout.",
                    "buttonNoAction": function () { window.location.href = '/oasis/employee/logout' },
                    "buttonNoLabel": "Logout",
                    "buttonYesLabel": "See Dashboard"
                };
            }
            this.createDialog(dialogOptions);
        }
    }

}).mount("#employee-dashboard");